import { useTranslation } from 'react-i18next';
import { Ancillarie } from '../Summary.model';
import { SummaryItem } from './summary-item/SummaryItem';
import { SummarySubItem } from './summary-sub-item/SummarySubItem';
import { Box } from '../..';
import styles from '../Summary.module.css';
import { SummaryArticle } from './summary-article/SummaryArticle';

type AncillarieItemProps = { ancillarie: Ancillarie };

export const AncillarieItem = (props: AncillarieItemProps) => {
	const { t } = useTranslation('summary');
	const { ancillarie } = props;
	return (
		<SummaryItem
			title={t(`ANCILLARIES_${ancillarie.code}`)}
			total={{
				title: t(`ANCILLARIES_TOTAL_${ancillarie.code}`),
				price: ancillarie.total
			}}
		>
			{ancillarie.segments
				? ancillarie.segments.map((segment) => {
						return (
							<SummarySubItem key={segment.id} text={segment.title}>
								<Box className={styles.item__children}>
									{segment.items.map((item) => {
										return (
											<SummaryArticle
												key={item.code}
												text={item.description}
												price={item.price}
												amount={item.amount}
											></SummaryArticle>
										);
									})}
								</Box>
							</SummarySubItem>
						);
					})
				: ancillarie.type && (
						<Box className={styles.item__children}>
							<SummaryArticle text={ancillarie.type} price={ancillarie.total}></SummaryArticle>
						</Box>
					)}
		</SummaryItem>
	);
};
AncillarieItem.displayName = 'AncillarieItem';
